import React, { useEffect, useState } from "react";
import {Scoodle2FASetup} from "../../../components/05pages/scoodle/Scoodle2FASetup/Scoodle2FASetup";
import QueryString from "querystring";
import { ScoodleDefaultPage } from "../../../components/04templates/scoodle/defaultPage/ScoodleDefaultPage";
import { Link } from "pu-crossproduct-components/build/components/Molecules/Navigation/Link";
import { useTranslation } from "react-i18next";

interface AccountData {
    accountName: string
}

const defaultAccountData = {accountName:""};

interface IState {
    isLoading: boolean;
    isError: boolean;
    errorMessage: string;
    accountData: AccountData;
}

export const Scoodle2FASetupPage : React.FC = props => {
    const [state, setState] = useState<IState>({
        isLoading: true,
        isError: false,
        errorMessage: "",
        accountData: defaultAccountData
    });
    const {t} = useTranslation();

    const handleError = (e: any) => {
        setState({...state, isError: true, isLoading: false, accountData: defaultAccountData, errorMessage: JSON.stringify(e)})
        console.error(JSON.stringify(e));
    }

    const handleDataLoaded = (data: AccountData) => {
        setState({...state, isError: false, isLoading: false, accountData: data, errorMessage: JSON.stringify("")})
    }

    // Data Loader
    useEffect(() => {(async () => {
        try {
            const response = await fetch('/Scoodle2FA/SetupAccountData')
            if (response.ok) {
                // Server returned Ok -> Fetching data
                const data = (await response.json()) as AccountData;
                handleDataLoaded(data);
            } else {
                // Server returned an error
                handleError(response.body)
            }
        } catch (e) {
            // Something went very wrong
            handleError(e.message);
        }
    })()}, []);

    const queryString = QueryString.parse(window.location.search.substring(1));
    const returnUrl = queryString["returnUrl"] as string;

    if (state.isLoading)
        return <ScoodleDefaultPage>Loading ...</ScoodleDefaultPage>;

    if (state.isError)
        return <ScoodleDefaultPage>
            <div style={{color: "red"}}>{t('twoFactorScoodleGeneralErrorTitle')}</div><br />
            <p>{t('twoFactorScoodleGeneralErrorDescription')}</p>
            <br />
            <Link href="https://www.scoodle.be">{t('twoFactorScoodleGeneralErrorRetryButton')}</Link>
        </ScoodleDefaultPage>;

    return <Scoodle2FASetup 
        accountName={state.accountData.accountName}
        onStartSetup={() => window.location.href = '/Scoodle2FA/StartSetup?returnUrl=' + encodeURIComponent(returnUrl) } />
}